import rimg from '@pixelunion/rimg-shopify'; // eslint-disable-line
import AsyncView from 'shopify-asyncview';

export default class ProductRecommendations {
  constructor(section) {
    this.section = section;
    this.productId = section.data.productId;
    this.limit = section.data.settings.limit;

    this.recommendationContainer = document.querySelector('[data-product-recommendations-container]');

    this._loadRecommendations = this._loadRecommendations.bind(this);
    this._reloadRecommendations = this._reloadRecommendations.bind(this);
    this._loadMoreRecommendations = this._loadMoreRecommendations.bind(this);

    this._loadRecommendations();

    window.addEventListener('shopify:section:load', this._reloadRecommendations);
    window.addEventListener('vogue:loadRecommended', this._loadMoreRecommendations);
  }

  _loadRecommendations() {
    const recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=product-recommendations&limit=${this.limit}&product_id=${this.productId}`;

    AsyncView.load(
      recommendUrl,
    ).done(({ html }) => {
      if (!html.length) {
        this.recommendationContainer.innerHTML = '';
        return;
      }

      this.recommendationContainer.innerHTML = html;

      rimg.watch(this.recommendationContainer);

      const productItems = this.recommendationContainer.querySelectorAll('.recommended-product');

      if (productItems.length) {
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }
    });
  }

  // This method is only called inside of the theme editor when the user changes their setting
  // for enable single product view
  _reloadRecommendations() {
    this.recommendationContainer = document.querySelector('[data-product-recommendations-container]');
    this._loadRecommendations();
  }

  // This method is to be called when we need to load more recommended products for products other
  // than the first product in the collection.
  _loadMoreRecommendations(event) {
    const { productElement } = event.detail;
    const productId = productElement.getAttribute('data-product-id');

    this.recommendationContainer = productElement.querySelector('[data-product-recommendations-container]');
    this.productId = productId;
    this._loadRecommendations();
  }

  unload() {
    window.removeEventListener('shopify:section:load', this._reloadRecommendations);
    window.removeEventListener('vogue:loadRecommended', this._loadMoreRecommendations);
  }
}
